<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="mat-typography">
    {{message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>No</button>
    <button mat-button (click)="confirm()" cdkFocusInitial>Yes</button>
</mat-dialog-actions>